import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';

import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-customer-page-requests',
  templateUrl: './customer-page-requests.component.html',
  styleUrls: ['./customer-page-requests.component.sass']
})
export class CustomerPageRequestsComponent implements OnInit {

  @Input() customerId: string;

  public columns: Array<any> = [
    {
      title: 'Request ID',
      name: 'Id',
      cellClassName: ['btn-link cursor-pointer'],
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by ID'
      },
      width: '325px'
    },
    {
      title: 'Request Date',
      name: 'RequestDate',
      type: 'date',
      sort: 'desc',
      filtering: {
        filterType: 'daterange',
        maxDate: new Date(),
        placeholder: 'Filter by date'
      }
    },
    {
      title: 'Request Status',
      name: 'ResponseStatus',
      sort: '',
      filtering: {
        filterType: 'select',
        placeholder: 'Filter by status',
        filterData: []
      }
    },
    {
      title: 'Package ID',
      name: 'PackageId',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by Package ID'
      },
      width: '325px'
    }
  ];

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    className: ['table-striped', 'table-bordered'],
    filtering: { filterString: '' }
  };

  public requestsData: Array<any> = [];
  public statusFilterData: Array<string> = [];

  constructor(
    private router: Router, 
    private api: ApiService
  ) { }

  ngOnInit(): void {
    this.api.get(`customers/${this.customerId}/requestresponse`, (result: Array<any>) => {
      this.requestsData = result.map(({PackageId = '', ResponseStatus = '', ...request}) => ({
        PackageId: PackageId == null ? 'NULL' : PackageId, 
        ResponseStatus: ResponseStatus == null ? 'NULL' : ResponseStatus, 
        ...request
      }));
      let statusFilterData = this.requestsData.map(({ResponseStatus}) => ResponseStatus);
      statusFilterData = statusFilterData.filter((status, index) => status && statusFilterData.indexOf(status) === index);

      let statusFiltering = this.columns.find(request => request.name === 'ResponseStatus').filtering;
      statusFiltering.filterData = statusFilterData;
    });
  }

  public onCellClick(cell: any): any {
    switch (cell.column.name) {
      case 'Id':
        const { Id, RequestDate } = cell.row;
        this.router.navigate(['requests', Id], {queryParams: {time: RequestDate}});
        break;
      default:
        break;
    }
  }

}
